import React, { useState, useEffect, useReducer } from "react";
import RadioGroup from "devextreme-react/radio-group";
import ScrollView from "devextreme-react/scroll-view";
import SelectBox from "devextreme-react/select-box";
import * as utils from "../../common/utils";
import Uploader from "../common/FileUploader";
import _, { indexOf } from "lodash";
import * as actions from "../../actions/dashboard";
import dashboardReducer from "../../reducers/dashboard";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import config from "../../common/config";

const initialState = { surveyNameData: [] };
export default ({
  onWidgetSelect,
  closeWidget,
  editWidgetInfo,
  template,
  tierId,
  subTiers,
  isBaseLayout,
}) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  let { surveyNameData } = state;

  let titleOptions = template
    .filter((d) => {
      if (utils.SQDCP.indexOf(d.title) == -1) {
        return d;
      }
    })
    .map((d) => d.title);
  const [active, setActive] = useState(
    editWidgetInfo ? editWidgetInfo.itemId : "rail"
  );
  const [widgetTitle, setWidgetTitle] = useState(
    editWidgetInfo ? editWidgetInfo.title : "Action Rail"
  );
  const [widgetHtml, setWidgetHtml] = useState(
    editWidgetInfo ? editWidgetInfo.description : ""
  );
  const [sqdcp, setSqdcp] = useState(
    editWidgetInfo && editWidgetInfo.filter ? editWidgetInfo.filter : "All"
  );
  const [surveyNamw, setSurveyNamw] = useState(
    editWidgetInfo && editWidgetInfo.filter ? editWidgetInfo.filter : ""
  );
  const [sqdicp, setSqdicp] = useState(
    template.filter((d) => {
      if (d.isActive === true) return d.title;
    })
  );
  const TRACK_TYPE = [
    { id: "All", name: "Gemba" },
    { id: "attendance", name: "Attendance" },
  ];
  const SQDCP = ["All"].concat(utils.SQDCP).concat(
    titleOptions.filter((d) => {
      if (d != "Performance") return d;
    })
  );

  const [RPSSQDICP, setRPSSQDICP] = useState([]);

  useEffect(() => {
    let arraVals = [];
    for (const element of sqdicp) {
      arraVals.push(element.title);
    }
    setRPSSQDICP(["All"].concat(arraVals));
  }, []);

  useEffect(() => {
    actions.fetchMultiSurveyNameData(dispatch, tierId);
  }, [tierId]);

  const allowedWidgets = ["rail", "downtimeReason", "ophWidget", "rpsWidget", "sa3Widget", "deliveryMetricOPH"]

  const widgets =
    subTiers && subTiers.length > 0 && subTiers[0]["tierLevel"] >= 3
    ? !config.DEV_DISPLAY_OPTIONS ? utils.WIDGETS.filter(widget => allowedWidgets.includes(widget.id)) : utils.WIDGETS
    : !config.DEV_DISPLAY_OPTIONS ? utils.WIDGETS.filter(widget => allowedWidgets.includes(widget.id)) : utils.WIDGETS.filter((x) => x.id !== "sa3Widget");
      
  const selectHandler = (e) => {
    if (editWidgetInfo && editWidgetInfo.itemId === e.value) {
      setWidgetTitle(editWidgetInfo.title);
      setWidgetHtml(editWidgetInfo.description);
    } else {
      let widgetInfo = widgets[_.findIndex(widgets, ["id", e.value])];
      if (widgetInfo) setWidgetTitle(widgetInfo.label);
      setWidgetHtml("");
    }
    setActive(e.value);
  };

  const onImgUpload = (d) => {
    setWidgetHtml(d);
  };

  const addWidget = () => {
    let widgetId = editWidgetInfo ? editWidgetInfo.widgetId : null;
    if (active === "rpsWidget")
      onWidgetSelect(active, widgetTitle, widgetHtml, widgetId, sqdcp);
    else if (active === "sa3Widget")
      onWidgetSelect(active, widgetTitle, widgetHtml, widgetId, sqdcp);
    else if (active === "multiSurveyWidget")
      onWidgetSelect(active, widgetTitle, widgetHtml, widgetId, surveyNamw);
    else onWidgetSelect(active, widgetTitle, widgetHtml, widgetId, sqdcp);

    closeWidget();
  };
  return (
    <Popup
      width={790}
      height={480}
      visible={true}
      hideOnOutsideClick={false}
      showCloseButton={false}
      title="Select a field"
    >
      <div
        className={
          "select-component show-component " +
          (active ? "open-additional-info" : "")
        }
      >
        {/*<div className={"select-component show-component " + (active === 'html' || active === 'tableau' ? "open-additional-info": '')}>*/}
        <div className="add-widget-scroll">
          <ScrollView
            id="sitecontent123"
            {...{
              showScrollbar: "never",
              scrollByContent: true,
              scrollByThumb: true,
            }}
          >
            <div className="select-component-wrap">
              <div className="dx-field">
                <div className="dx-field-value">
                  <RadioGroup
                    displayExpr="label"
                    valueExpr="id"
                    value={active}
                    items={widgets}
                    onValueChanged={selectHandler}
                  />
                </div>
              </div>
            </div>
          </ScrollView>
          <div>
            <button
              className="btn add-widget-btn"
              onClick={() => closeWidget()}
            >
              Cancel
            </button>
            <button
              title="Please select a widget to save."
              className="btn add-widget-btn"
              disabled={active ? false : true}
              onClick={addWidget}
            >
              Save
            </button>
          </div>
        </div>

        <div className="additional-info">
          <div className="form-group">
            <input
              type="text"
              placeholder="Add a title"
              value={widgetTitle}
              onChange={(e) => setWidgetTitle(e.target.value)}
            />
            {(active === "tableau" || active == "html") && (
              <textarea
                placeholder="Add description/code here"
                value={widgetHtml}
                onChange={(e) => setWidgetHtml(e.target.value)}
              ></textarea>
            )}
            {/* {active === 'rail' && <span className="filter-adj"><SelectBox items={SQDCP} value={sqdcp} onValueChanged={e => setSqdcp(e.value)} /></span>} */}
            {active === "rail" && (
              <span className="filter-adj">
                <SelectBox
                  items={RPSSQDICP}
                  value={sqdcp}
                  onValueChanged={(e) => {
                    setSqdcp(e.value);
                  }}
                />
              </span>
            )}
            {active === "rpsWidget" && (
              <span className="filter-adj">
                <SelectBox
                  items={RPSSQDICP}
                  value={sqdcp}
                  onValueChanged={(e) => setSqdcp(e.value)}
                />
              </span>
            )}
            {!isBaseLayout &&
              active === "sa3Widget" &&
              subTiers &&
              subTiers.length > 0 &&
              subTiers[0]["tierLevel"] >= 3 && (
                <span className="filter-adj">
                  <SelectBox
                    items={RPSSQDICP}
                    value={sqdcp}
                    onValueChanged={(e) => setSqdcp(e.value)}
                  />
                </span>
              )}
            {active === "multiSurveyWidget" && surveyNameData && (
              <span className="filter-adj">
                <SelectBox
                  items={surveyNameData.filter((x) => x.isActive == true)}
                  placeholder={surveyNamw}
                  value={surveyNamw}
                  displayExpr="surveyName"
                  valueExpr="surveyName"
                  onValueChanged={(e) => setSurveyNamw(e.value)}
                />
                {/* <SelectBox
                items={surveyNameData}
                value={surveyNamw}
                onValueChanged={(e) => setSurveyNamw(e.value)}
              /> */}
              </span>
            )}

            {!isBaseLayout &&
              active === "ophWidget" &&
              subTiers &&
              subTiers.length > 0 &&
              subTiers[0]["tierLevel"] == 1 && (
                <span className="filter-adj">
                  <SelectBox
                    items={subTiers}
                    value={sqdcp == "All" ? Number(tierId) : sqdcp}
                    displayExpr="tierName"
                    valueExpr="tierID"
                    searchEnabled={true}
                    onValueChanged={(e) => {
                      setSqdcp(e.value);
                    }}
                  />
                </span>
              )}
            {active === "gemba" && (
              <span className="filter-adj">
                <SelectBox
                  items={TRACK_TYPE}
                  value={sqdcp}
                  displayExpr="name"
                  valueExpr="id"
                  onValueChanged={(e) => {
                    let title = TRACK_TYPE.filter((d) => {
                      if (d.id == e.value) return d;
                    });
                    setWidgetTitle(title[0]["name"]);
                    setSqdcp(e.value);
                  }}
                />
              </span>
            )}
            {active == "inlineFile" && (
              <div>
                {" "}
                <Uploader onImgUpload={onImgUpload} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Popup>
  );
};
